module.exports = __webpack_public_path__ + "img/tiefgekuehlt.13269e79.svg";